<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Number:</label>
	<input [disabled]="Imported == true" class="form-control" type="text" placeholder="Bus Number" [(ngModel)]="BusNbr" />

	<label>Description:</label>
	<input class="form-control" type="text" placeholder="Bus Name/Description" [(ngModel)]="BusDesc" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button *ngIf="EditMode == false" [disabled]="Imported == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button *ngIf="EditMode == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
